import React from 'react'
import { useStoreConfig } from '@config/hooks/useStoreConfig'
import { JsonLdScript } from '../JsonLdScript/JsonLdScript'

type PotentialAction = {
    '@type': 'SearchAction'
    target: string
    'query-input': string
}

export const SearchBox = ({
    asPath
}: {
    asPath: string
}): JSX.Element | null => {
    const { seo, base } = useStoreConfig()
    if (
        !seo.searchBox ||
        asPath !== seo.searchBox.allowedPath ||
        !seo.searchBox.potentialActions
    ) {
        return null
    }
    const content = {
        '@context': 'https://schema.org',
        '@type': 'WebSite',
        url: base.url.baseUrl,
        potentialAction: [] as PotentialAction[]
    }

    seo.searchBox.potentialActions.forEach((action) => {
        if (action && action.target && action.queryInput) {
            content['potentialAction'].push({
                '@type': 'SearchAction',
                target: `${action.target}=${action.queryInput}`,
                'query-input': `required name=${action.queryInput}`
            })
        }
    })

    return <JsonLdScript id="search-box-json-ld" data={content} />
}
